export default __webpack_public_path__ + "static/media/rewards.f05573d7.png";